const loginForm = document.getElementById("wc_login_user");

if( loginForm ) {
    let ajaxUrl = ajax_callback_data.ajax_url;
    let loginPage = ajax_callback_data.login_page;
    
    loginForm.addEventListener("submit", function (event) {
        event.preventDefault();
        
        let loginAcount = true;
        let email = document.getElementById('username').value.trim();
        let password = document.getElementById('password').value.trim();
        let isRememberMeChecked = document.getElementById('rememberme').checked;

        let productId = document.getElementById('product-id').value;

        document.querySelectorAll('.error').forEach(element => {
            element.remove();
        });

        if( password == '' ) {
            loginAcount = false;
            afrigar_message_element_input_validate('password', 'error', 'Password is required');
        } else {
            loginAcount = true;
        }
        
        if( email == '' ) {
            loginAcount = false;
            afrigar_message_element_input_validate('username', 'error', 'Email is required');

        } else {
            if( ! validateEmail(email) ) {
                loginAcount = false;
                afrigar_message_element_input_validate('username', 'error', 'Please enter valid email');
            } else {
                if( loginAcount ) {
                    afrigar_loading('flex');
                    var formData = {
                        action: "login_validate_user",
                        email: email,
                        password: password,
                        rememberMe: isRememberMeChecked,
                        productId: productId,
                    };

                    jQuery.ajax({
                        url: ajaxUrl,
                        type: "POST",
                        data: formData,
                        success: function (response) {
                            logged = JSON.parse(response);

                            if( logged.success ) {
                                window.location.href = logged.message;

                            } else {
                                if( logged.message == 'email' ) {
                                    afrigar_message_element_input_validate('username', 'error', 'Email is incorrect');
                                }
                                if(logged.message == 'password') {
                                    afrigar_message_element_input_validate('password', 'error', 'Password is incorrect');

                                }
                                afrigar_loading('none');
                            }
                        },
                        error: function () {
                            window.location.href = loginPage;
                        },
                    });
                }
            }
        }

    });
}